import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const SVG = () => (
    <svg className="card-icon" width="30" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.9493 26.5C12.774 26.5 9.89903 25.2126 7.81787 23.1315C5.73671 21.0503 4.44935 18.1753 4.44935 15C4.44935 11.8247 5.73671 8.94969 7.81787 6.86853C9.89903 4.78737 12.774 3.50001 15.9493 3.50001C19.1247 3.50001 21.9997 4.78737 24.0808 6.86853C26.162 8.94969 27.4493 11.8247 27.4493 15C27.4493 18.1753 26.162 21.0503 24.0808 23.1315C21.9997 25.2126 19.1247 26.5 15.9493 26.5Z"
            stroke="white"
            strokeWidth="1.8"
        />
        <path
            d="M20.9493 14.9998L15.9493 19.9998L10.9493 14.9998M15.9493 18.1248L15.9493 9.99976"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function C_NA() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const cards: any[] = [
        {
            title: t('secC_card1_title'),
            desc: t('secC_card1_desc'),
            target: '#outdoor-recreation-D',
            img:
                locale === 'za'
                    ? [
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578854758/3_1_za.png',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717579541331/3_1_768_za.png',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717579541157/3_1_375_za.png',
                      ]
                    : [
                          '/responsive/picture/outdoor-recreation/3_1_na.jpg',
                          '/responsive/picture/outdoor-recreation/3_1_768_na.jpg',
                          '/responsive/picture/outdoor-recreation/3_1_375_na.jpg',
                      ],
        },
        {
            title: t('secC_card2_title'),
            desc: t('secC_card2_desc'),
            target: '#outdoor-recreation-J',
            img:
                locale === 'za'
                    ? [
                          '/responsive/picture/outdoor-recreation/3_2_za_1366.png',
                          '/responsive/picture/outdoor-recreation/3_2_za_1024.png',
                          '/responsive/picture/outdoor-recreation/3_2_za_768.png',
                      ]
                    : [
                          '/responsive/picture/outdoor-recreation/3_2_na.jpg',
                          '/responsive/picture/outdoor-recreation/3_2_768_na.jpg',
                          '/responsive/picture/outdoor-recreation/3_2_375_na.jpg',
                      ],
        },
    ];

    return (
        <div id="outdoor-recreation-C" className={`outdoor-recreation-C ${css['outdoor-recreation-C']}`}>
            <div className="text-info">
                <h2 className="title">{t('secC_title')}</h2>
                <p className="desc">{t('secC_desc')}</p>
            </div>
            <ul className="cards">
                {cards?.map((card: any, k: number) => (
                    <li className="card" key={k}>
                        <a href={card?.target}>
                            <div className="card-img">
                                <EFPicture src={card.img[0]} srcPad={card.img[1]} srcMobile={card.img[2]} alt={card?.title} />
                            </div>
                            <div className="card-info">
                                <h3 className="card-title">{card?.title}</h3>
                                <div className="card-text">
                                    <p className="card-desc">{card?.desc}</p>
                                    <SVG />
                                </div>
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}
